import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepOtherStarr.sectionTitle',
    defaultMessage: 'Section 8 - Other Claims',
  },
  pageDescription: {
    id: 'fastCover.stepOtherStarr.pageDescription',
    defaultMessage: 'This section is for claims related to Accidental Death and Dismemberment; and Repatriation Expenses.',
  },
  yes: {
    id: 'fastCover.stepOtherStarr.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepOtherStarr.no',
    defaultMessage: 'No',
  },
  isThereAnyThingElseYouWouldLikeToClaimFor: {
    id: 'fastCover.stepOtherStarr.isThereAnyThingElseYouWouldLikeToClaimFor',
    defaultMessage: 'Is there anything else you would like to claim for?',
  },
  areYouClaimingForPersonalLiability: {
    id: 'fastCover.stepOtherStarr.areYouClaimingForPersonalLiability',
    defaultMessage: 'Are you claiming for Personal Liability?',
  },
  areYouClaimingForGolfPackOptionalCover: {
    id: 'fastCover.stepOtherStarr.areYouClaimingForGolfPackOptionalCover',
    defaultMessage: 'Are you claiming for Golf Pack Optional Cover?',
  },
  areYouClaimingForBicyclePackOptionalCover: {
    id: 'fastCover.stepOtherStarr.areYouClaimingForBicyclePackOptionalCover',
    defaultMessage: 'Are you claiming for Bicycle Pack Optional Cover?',
  },
  toAssistYourClaim: {
    id: 'fastCover.stepOtherStarr.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.stepOtherStarr.toAssistYourClaim',
    defaultMessage: 'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.stepOtherStarr.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.stepOtherStarr.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.stepOtherStarr.document1',
    defaultMessage: 'A copy of your Travel Itinerary',
  },
  document2: {
    id: 'fastCover.stepOtherStarr.document2',
    defaultMessage: 'A copy of all relevant invoices being claimed',
  },
  document3: {
    id: 'fastCover.stepOtherStarr.document3',
    defaultMessage: 'Any other relevant supporting documents',
  },
  document4: {
    id: 'fastCover.stepOtherStarr.document4',
    defaultMessage: 'A copy of any incident report relevant to the cause of the claim',
  },
  document5: {
    id: 'fastCover.stepOtherStarr.document5',
    defaultMessage: 'Copy of police report ',
  },
  document6: {
    id: 'fastCover.stepOtherStarr.document6',
    defaultMessage: 'A damage/repair report for damaged Golf equipment or bicycle',
  },
  document7: {
    id: 'fastCover.stepOtherStarr.document7',
    defaultMessage: 'Purchase receipt or other evidence of ownership for each item claimed',
  },
  provideExplanation: {
    id: 'fastCover.stepOtherStarr.provideExplanation',
    defaultMessage: 'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  pleaseTellUs: {
    id: 'fastCover.stepOtherStarr.pleaseTellUs',
    defaultMessage: 'If your item claimed was lost, stolen, damaged or delayed please tell us:',
  },
  howItHappened: {
    id: 'fastCover.stepOtherStarr.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepOtherStarr.whereYouWereInRelationToTheItem',
    defaultMessage: '2. Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepOtherStarr.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.stepOtherStarr.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.stepOtherStarr.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.stepOtherStarr.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.stepOtherStarr.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.stepOtherStarr.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.stepOtherStarr.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.stepOtherStarr.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.stepOtherStarr.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.stepOtherStarr.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.stepOtherStarr.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.stepOtherStarr.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.stepOtherStarr.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.stepOtherStarr.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.stepOtherStarr.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.stepOtherStarr.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  expensesClaimed: {
    id: 'fastCover.stepOtherStarr.expensesClaimed',
    defaultMessage: 'Expenses Claimed',
  },
  expensesClaimedOther: {
    id: 'fastCover.stepOtherStarr.expensesClaimed',
    defaultMessage: 'Other Expenses Claimed',
  },
  expensesClaimedTitle: {
    id: 'fastCover.stepOtherStarr.expensesClaimedTitle',
    defaultMessage: 'Expense {index}',
  },
  addOtherExpense: {
    id: 'fastCover.stepOtherStarr.addOtherExpense',
    defaultMessage: 'Add Other Expense',
  },
  addExpense: {
    id: 'fastCover.stepOtherStarr.addExpense',
    defaultMessage: 'Add Expense',
  },
  dateOfExpense: {
    id: 'fastCover.stepOtherStarr.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  description: {
    id: 'fastCover.stepOtherStarr.description',
    defaultMessage: 'Description of expense claimed',
  },
  amount: {
    id: 'fastCover.stepOtherStarr.amount',
    defaultMessage: 'Amount',
  },
  currency: {
    id: 'fastCover.stepOtherStarr.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.stepOtherStarr.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  australianDollars: {
    id: 'fastCover.stepOtherStarr.australianDollars',
    defaultMessage: 'Australian dollars',
  },
  supportingDocumentsAttached: {
    id: 'fastCover.stepOtherStarr.supportingDocumentsAttached',
    defaultMessage: 'Supporting Documents Attached?',
  },
  supportingDocumentsAttachedNote: {
    id: 'fastCover.stepOtherStarr.supportingDocumentsAttachedNote',
    defaultMessage: 'You can attach supporting documents later in this form',
  },
  isRequired: {
    id: 'fastCover.stepOtherStarr.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  costClaimedTableRequired: {
    id: 'fastCover.stepOtherStarr.costClaimedTableRequired',
    defaultMessage: 'Costs Claimed table fields are required fields.',
  },
  golfExpensesClaimed: {
    id: 'fastCover.stepOtherStarr.golfExpensesClaimed',
    defaultMessage: 'Golf Expenses Claimed',
  },
  golfExpense: {
    id: 'fastCover.stepOtherStarr.golfExpenses',
    defaultMessage: 'Golf Expense {index}',
  },
  addGolfExpense: {
    id: 'fastCover.stepOtherStarr.addGolfExpense',
    defaultMessage: 'Add Golf Expense',
  },
  bicycleExpensesClaimed: {
    id: 'fastCover.stepOtherStarr.bicycleExpensesClaimed',
    defaultMessage: 'Bicycle Expenses Claimed',
  },
  bicycleExpense: {
    id: 'fastCover.stepOtherStarr.bicycleExpense',
    defaultMessage: 'Bicycle Expense {index}',
  },
  addBicycleExpense: {
    id: 'fastCover.stepOtherStarr.addBicycleExpense',
    defaultMessage: 'Add Bicycle Expense',
  },
  other1: {
    id: 'fastCover.stepOtherStarr.other1',
    defaultMessage: 'A copy of any incident report relevant to the cause of the claim',
  },
  other2: {
    id: 'fastCover.stepOtherStarr.other1',
    defaultMessage: 'A copy of all relevant invoices being claimed',
  },
  other3: {
    id: 'fastCover.stepOtherStarr.other1',
    defaultMessage: 'Any other relevant supporting documents',
  },

  nameOfDeceased: {
    id: 'fastCover.stepOtherStarr.namOfDeceased',
    defaultMessage: 'Name of Deceased / Patient / Relation',
  },

  theClaimIsBeingMadeUnder: {
    id: 'fastCover.stepOtherStarr.theClaimIsBeingMadeUnder',
    defaultMessage: 'The claim is being made under',
  },

  dateOfInjury: {
    id: 'fastCover.stepOtherStarr.dateOfInjury',
    defaultMessage: 'Date of  Injury / Death',
  },

  checkNameOfDeceased: {
    id: 'fastCover.stepOtherStarr.checkNameOfDeceased',
    defaultMessage: 'Nature of Dismemberment',
  },

  placeWhereAccidentHappened: {
    id: 'fastCover.stepOtherStarr.placeWhereAccidentHappened',
    defaultMessage: 'Place where accident occurred',
  },

  describeWhereTheAccidentOccurred: {
    id: 'fastCover.stepOtherStarr.describeWhereTheAccidentOccurred',
    defaultMessage: 'Describe where the accident occurred',
  },

  describeHowTheAccidentOccurred: {
    id: 'fastCover.stepOtherStarr.describeHowTheAccidentOccurred',
    defaultMessage: 'Describe how the accident occurred',
  },

  accidentalDeath: {
    id: 'fastCover.stepOtherStarr.accidentalDeath',
    defaultMessage: 'Accidental Death',
  },

  accidentalDismemberment: {
    id: 'fastCover.stepOtherStarr.accidentalDismemberment',
    defaultMessage: 'Accidental Dismemberment',
  },

  rightHand: {
    id: 'fastCover.stepOtherStarr.rightHand',
    defaultMessage: 'Right Hand',
  },

  leftHand: {
    id: 'fastCover.stepOtherStarr.leftHand',
    defaultMessage: 'Left Hand',
  },

  bothHands: {
    id: 'fastCover.stepOtherStarr.bothHands',
    defaultMessage: 'Both Hands',
  },

  rightFoot: {
    id: 'fastCover.stepOtherStarr.rightFoot',
    defaultMessage: 'Right Foot',
  },

  leftFoot: {
    id: 'fastCover.stepOtherStarr.leftFoot',
    defaultMessage: 'Left Foot',
  },

  bothFeet: {
    id: 'fastCover.stepOtherStarr.bothFeet',
    defaultMessage: 'Both Feet',
  },

  sightOfRightEye: {
    id: 'fastCover.stepOtherStarr.sightOfRightEye',
    defaultMessage: 'Sight of Right Eye',
  },

  sightOfLeftEye: {
    id: 'fastCover.stepOtherStarr.sightOfLeftEye',
    defaultMessage: 'Sight of Left Eye',
  },

  sightOfBothEyes: {
    id: 'fastCover.stepOtherStarr.sightOfBothEyes',
    defaultMessage: 'Sight of Both Eyes',
  },

  areYouClaimingForAccidentalDeathAndDismemberment: {
    id: 'fastCover.stepOtherStarr.areYouClaimingForAccidentalDeathAndDismemberment',
    defaultMessage: 'Are you claiming for Accidental Death & Dismemberment?',
  },

  areYouClaimingForRepatriationExpenses: {
    id: 'fastCover.stepOtherStarr.areYouClaimingForBurialOrRepatriationExpenses',
    defaultMessage: 'Are you claiming for Repatriation expenses?',
  },

  areYouClaimingForBurialExpenses: {
    id: 'fastCover.stepOtherStarr.areYouClaimingForBurialOrRepatriationExpenses',
    defaultMessage: 'Are you claiming for Burial expenses?',
  },

  benefitAreYouClaimingFor: {
    id: 'fastCover.stepOtherStarr.benefitAreYouClaimingFor',
    defaultMessage: 'Which Benefit are you claiming for?',
  },

  localBurial: {
    id: 'fastCover.stepOtherStarr.localBurial',
    defaultMessage: 'Local Burial',
  },

  repatriation: {
    id: 'fastCover.stepOtherStarr.repatriation',
    defaultMessage: 'Repatriation',
  },

  assistance: {
    id: 'fastCover.stepOtherStarr.assistance',
    defaultMessage: 'Assistance Company/Claims Administrator Approval Number',
  },

  dateApproved: {
    id: 'fastCover.stepOtherStarr.dateApproved',
    defaultMessage: 'Date Approved',
  },

  causeOfDeath: {
    id: 'fastCover.stepOtherStarr.causeOfDeath',
    defaultMessage: 'Cause Of Death',
  },

  dateOfDeath: {
    id: 'fastCover.stepOtherStarr.dateOfDeath',
    defaultMessage: 'Date Of Death',
  },

  stateOfDeath: {
    id: 'fastCover.stepOtherStarr.stateOfDeath',
    defaultMessage: 'State Of Death',
  },

  countryOfDeath: {
    id: 'fastCover.stepOtherStarr.countryOfDeath',
    defaultMessage: 'Country Of Death',
  },

  wasTheMemberHospitalized: {
    id: 'fastCover.stepOtherStarr.wasTheMemberHospitalized',
    defaultMessage: 'Was the Member Hospitalized',
  },

  from: {
    id: 'fastCover.stepOtherStarr.from',
    defaultMessage: 'From',
  },

  to: {
    id: 'fastCover.stepOtherStarr.to',
    defaultMessage: 'To',
  },

  nameOfFuneralServiceProvider: {
    id: 'fastCover.stepOtherStarr.nameOfFuneralServiceProvider',
    defaultMessage: 'Name of Funeral Service Provider',
  },

  costOfLocalBurial: {
    id: 'fastCover.stepOtherStarr.costOfLocalBurial',
    defaultMessage: 'Cost of Local Burial',
  },

  invoiceNumber: {
    id: 'fastCover.stepOtherStarr.invoiceNumber',
    defaultMessage: 'Invoice Number',
  },

  familyMemberProvidingInformation: {
    id: 'fastCover.stepOtherStarr.familyMemberProvidingInformation',
    defaultMessage: 'Family Member providing information (Claimant)',
  },

  relationshipToMember: {
    id: 'fastCover.stepOtherStarr.relationshipToMember',
    defaultMessage: 'Relationship to Member',
  },

  address: {
    id: 'fastCover.stepOtherStarr.address',
    defaultMessage: 'Address',
  },

  cityOrTown: {
    id: 'fastCover.stepOtherStarr.cityOrTown',
    defaultMessage: 'City Or Town',
  },

  country: {
    id: 'fastCover.stepOtherStarr.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.stepOtherStarr.postalCode',
    defaultMessage: 'Postal Code',
  },

  phoneNumber: {
    id: 'fastCover.stepOtherStarr.phoneNumber',
    defaultMessage: 'Phone Number',
  },
  checkEventDate: {
    id: 'fastCover.stepOtherStarr.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },

  expenseFor: {
    id: 'fastCover.stepOtherStarr.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfItem: {
    id: 'fastCover.stepOtherStarr.descriptionOfItem',
    defaultMessage: 'Description of Item',
  },
  dateOfExpenses: {
    id: 'fastCover.stepOtherStarr.dateOfExpenses',
    defaultMessage: 'Date of Expense',
  },
  amountCreditedOrRefunded: {
    id: 'fastCover.stepOtherStarr.amountCreditedOrRefunded',
    defaultMessage: 'Amount credited/refunded',
  },
  haveYouReceivedAnyCreditOrRefundFromTheServiceProvider: {
    id: 'fastCover.stepOtherStarr.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider',
    defaultMessage: 'Have you received any credit or refund from the service provider?',
  },
  itemWithIdx: {
    id: 'fastCover.stepOtherStarr.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  addItem: {
    id: 'fastCover.stepOtherStarr.addItem',
    defaultMessage: 'Add Expense',
  },
  personalLiability: {
    id: 'fastCover.stepOtherStarr.personalLiability',
    defaultMessage: 'Personal Liability',
  },
  personalLiabilityMessage: {
    id: 'fastCover.stepOtherStarr.personalLiabilityMessage',
    defaultMessage: 'This section is for claims relating to your legal liability to pay damages or compensation to a third party for injury or property damage caused by you.',
  },
  personalAccident: {
    id: 'fastCover.stepOtherStarr.personalAccident',
    defaultMessage: 'Personal Accident',
  },
  personalAccidentMessage: {
    id: 'fastCover.stepOtherStarr.personalAccidentMessage',
    defaultMessage: 'This section is for claims related to loss of life, loss of income, or total disablement caused by an injury.',
  },
  personalAccidentParnerInsuranceInternationalMedicalOnlyNZMessage: {
    id: 'fastCover.stepOtherStarr.personalAccidentParnerInsuranceInternationalMedicalOnlyNZMessage',
    defaultMessage: 'This section is for claims related to loss of life caused by an injury.',
  },
  personalAccidentHeadersOnDomesticAUAndInternationalStudent: {
    id: 'fastCover.stepOtherStarr.personalAccidentHeadersOnDomesticAUAndInternationalStudent',
    defaultMessage: 'This section is for claims related to loss of life or total disablement caused by an injury.',
  },
  lossOfIncome: {
    id: 'fastCover.stepOtherStarr.lossOfIncome',
    defaultMessage: 'Loss of Income',
  },
  totalPermanentDisablement: {
    id: 'fastCover.stepOtherStarr.totalPermanentDisablement',
    defaultMessage: 'Total permanent disablement',
  },
  lossOfLife: {
    id: 'fastCover.stepOtherStarr.lossOfLife',
    defaultMessage: 'Loss of Life',
  },
  whatAreYourExpensesRelatedTo: {
    id: 'fastCover.stepOtherStarr.whatAreYourExpensesRelatedTo',
    defaultMessage: 'What are your expenses related to?',
  },
  thisSectionIsForClaimsRelatedToLossOfLifeCausedByAnInjury: {
    id: 'fastCover.stepOtherStarr.whatAreYourExpensesRelatedTo',
    defaultMessage: 'This section is for claims related to loss of life caused by an injury.',
  },
  selectInsuredForExpense: {
    id: 'fastCover.stepOtherStarr.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
  lossInformation: {
    id: 'fastCover.stepOtherStarr.lossInformation',
    defaultMessage: 'Loss Information',
  },
  descriptionOfExpense: {
    id: 'fastCover.stepOtherStarr.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  costOfLocalBurialExpenseAmountClaimed: {
    id: 'fastCover.stepOtherStarr.costOfLocalBurialExpenseAmountClaimed',
    defaultMessage: 'Cost of Local Burial Expense amount claimed',
  },
  expenseAmountClaimed: {
    id: 'fastCover.stepOtherStarr.expenseAmountClaimed',
    defaultMessage: 'Expense amount claimed',
  },
  claimDescription: {
    id: 'fastCover.stepOtherStarr.claimDescription',
    defaultMessage: 'Claim Description',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepOther/messages.js